import { studentMoreTime } from '../../../../../img/images';
import { InstructionTickIcon } from '../../../../shared/icons/icons';
import { ILocalization } from '../../../../../localization/definitions/types';

interface Props {
    localization: ILocalization;
}
export const StudentMoreTimeSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='student-more-time-slide'>
                <img alt='' src={studentMoreTime} />
            </div>
        </div>
    );
};

export const StudentMoreTimeSlideImageSrc = studentMoreTime;

export const StudentMoreTimeSlideContent = ({ localization }: Props) => {
    const { studentMoreTimeSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial
            .supervisor.slides;

    return (
        <div className='tutorial-content-wrapper'>
            <h1>{studentMoreTimeSlide.whenStudents}​​​</h1>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    ​{studentMoreTimeSlide.youWillOccasionally}
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    <span className='instruction-content-bold'>
                        {studentMoreTimeSlide.accept}{' '}
                    </span>
                    {studentMoreTimeSlide.ifACompelling}
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    <span className='instruction-content-bold'>
                        {studentMoreTimeSlide.decline}{' '}
                    </span>
                    {studentMoreTimeSlide.andExplain}
                </div>
            </div>
        </div>
    );
};
